﻿import { Loader2 } from "lucide-react";

import { useAuthenticatedMe } from "@/features/organizers/api";
import { DashboardShell } from "@/components/dashboard-shell";

/**
 * Authenticated sayfalar için kısayol wrapper.
 * /me çağrısını yapıp DashboardShell'e companyName veriyor.
 * 401'de useAuthenticatedMe zaten /login'e yönlendiriyor.
 */
export function DashboardPage({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useAuthenticatedMe();

  if (isLoading || !data) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return <DashboardShell companyName={data.companyName}>{children}</DashboardShell>;
}
